
import { get } from 'vuex-pathify'

export default {
  inheritAttrs: false,
  props: {
    limit: {
      type: Number,
      default: 3
    }
  },
  computed: {
    validAreas: get('delivery/validAreas'),
    areas() {
      return this.validAreas.slice(0, this.limit)
    },
    total() {
      return this.validAreas.length
    },
    hidden() {
      return this.total > this.limit ? this.total - this.limit : 0
    }
  }
}
